import { render, staticRenderFns } from "./currentPhaseType.vue?vue&type=template&id=b4e5082c&scoped=true"
import script from "./currentPhaseType.vue?vue&type=script&lang=js"
export * from "./currentPhaseType.vue?vue&type=script&lang=js"
import style0 from "./currentPhaseType.vue?vue&type=style&index=0&id=b4e5082c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e5082c",
  null
  
)

export default component.exports